export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "AI": "",
        "AI provider lub model nie został skonfigurowany": "",
        "AI:": "",
        "Anuluj": "",
        "Asystent AI": "",
        "Bezpośredni": "",
        "Błąd": "",
        "Błąd podczas odtwarzania audio.": "",
        "Błąd podczas przetwarzania OCR": "",
        "Błąd podczas przetwarzania pliku": "",
        "Błąd podczas tworzenia embedding": "",
        "Błąd przesyłania pliku:": "",
        "Błąd przetwarzania": "",
        "Błąd przetwarzania DOCX": "",
        "Błąd przetwarzania PDF": "",
        "Błąd przetwarzania TXT": "",
        "Błąd serwisu AI:": "",
        "Błąd TTS": "",
        "Błąd:": "",
        "Brak danych w formularzu": "",
        "Brak dostępnych konwersacji.": "",
        "Brak lub nieprawidłowy imageBase64": "",
        "Brak lub nieprawidłowy tekst": "",
        "Brak oceny": "",
        "Brak pasujących fragmentów w załączonych dokumentach. Upewnij się, że dodałeś dokumenty do tej sesji.": "",
        "Brak pliku do przetworzenia": "",
        "Brak sessionId w zapytaniu": "",
        "Brak tokenu": "",
        "Brak wiadomości": "",
        "Brak wymaganych parametrów: fileId i sessionId": "",
        "Brak wymaganych parametrów: query i sessionId": "",
        "Chat": "",
        "Chat AI": "",
        "Content-Type musi być multipart/form-data": "",
        "Czat z dokumentami": "",
        "Czat z możliwością dodania i analizy dokumentów": "",
        "Czat z narzędziami": "",
        "Cześć, jestem Edito Bot. W czym mogę Ci pomóc?": "",
        "Czy na pewno chcesz usunąć tę konwersację?": "",
        "Czy na pewno chcesz usunąć tę wiadomość?": "",
        "Czytaj na głos": "",
        "Data dodania": "",
        "Data utworzenia": "",
        "Deployment/model TTS nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "",
        "dni temu": "",
        "Dodaj dokumenty": "",
        "Dodaj obraz": "",
        "Dodaj obrazy": "",
        "Dodaj plik": "",
        "Dokument podzielony na fragmenty - gotowy do użycia": "",
        "Dokument został przetworzony pomyślnie": "",
        "Domyślny": "",
        "Dopasowane instrukcje": "",
        "Dziękujemy za podzielenie się opinią": "",
        "Edytuj i wyślij ponownie": "",
        "Edytuj wiadomość": "",
        "Email użytkownika": "",
        "Formalny, rzeczowy, neutralny": "",
        "Formaty:": "",
        "godz. temu": "",
        "Gotowy do użycia": "",
        "Jasne, zdecydowane sformułowania, bez wahania": "",
        "Konfiguracja ai": "",
        "Konwersacja": "",
        "Konwersacje": "",
        "Kopiuj": "",
        "Krótkie, jasne odpowiedzi bez ozdobników": "",
        "Logi odpowiedzi chatu AI": "",
        "Luźny, naturalny, codzienny": "",
        "min temu": "",
        "Model do odpowiedzi": "",
        "Model embedding": "",
        "Model embedding nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "",
        "Model OCR": "",
        "Model OCR nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "",
        "Model TTS": "",
        "Monitoring": "",
        "Narzędzia AI": "",
        "Nazwa": "",
        "Nazwa konwersacji": "",
        "Nazwa użytkownika": "",
        "Nie można znaleźć odpowiedniego modelu chat lub dostawcy AI": "",
        "Nie można znaleźć odpowiedniego modelu embedding lub dostawcy AI": "",
        "Nie można znaleźć odpowiedniego modelu OCR lub dostawcy AI": "",
        "Nie można znaleźć odpowiedniego modelu TTS lub dostawcy AI": "",
        "Nie otrzymano treści od asystenta.": "",
        "Nie pomocna": "",
        "Nie udało się wyodrębnić treści z pliku": "",
        "Nie związana": "",
        "Niedozwolony format pliku. (${file.name})": "",
        "Nieobsługiwany typ pliku": "",
        "Nieobsługiwany typ pliku. Obsługiwane formaty: PDF, DOCX, TXT, JPG, PNG": "",
        "Nieprawidłowe żądanie: Brak sessionId lub message w treści żądania.": "",
        "Nieznany błąd": "",
        "Nowa": "",
        "Nowa konwersacja": "",
        "Obraz został przetworzony pomyślnie": "",
        "Ocena": "",
        "Oczekuje na przetworzenie": "",
        "Odpowiedź oceniona": "",
        "Odpowiedź systemu": "",
        "Pewny siebie": "",
        "Plik jest za duży": "",
        "Plik jest za duży. Maksymalny rozmiar": "",
        "Plik jest zbyt duży (${formatFileSize(file.size)}). Max: ${maxFileSizeLabel.value}": "",
        "Plik nie jest obrazem. Obsługiwane formaty: JPG, PNG, GIF, BMP, WebP": "",
        "Podaj nową nazwę...": "",
        "Podsumowanie tekstu": "",
        "Podsumuj tekst": "",
        "Polecenie początkowe": "",
        "Pomocna": "",
        "Popraw gramatykę": "",
        "Popraw gramatykę, pisownię i interpunkcję": "",
        "Powrót": "",
        "Profesjonalny": "",
        "Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać.": "",
        "Przejdź do konfiguracji, aby włączyć": "",
        "Przetwarzanie...": "",
        "Przetworzone pytania": "",
        "Przyjazny": "",
        "Pytanie użytkownika": "",
        "Repozytorium plików": "",
        "Rozpocznij nową, klikając przycisk poniżej.": "",
        "Rozwijaj tekst": "",
        "Rozwijanie tekstu": "",
        "Skracaj tekst": "",
        "Skracanie tekstu": "",
        "Swobodny": "",
        "System": "",
        "Szczegóły odpowiedzi bota": "",
        "Szczegóły wątku": "",
        "Sztuczna inteligencja": "",
        "Ta odpowiedź jest pomocna": "",
        "Ta odpowiedź jest powiązana": "",
        "Ta odpowiedź nie jest pomocna": "",
        "teraz": "",
        "Tłumacz PL - EN": "",
        "Tłumacz tekst między PL i EN": "",
        "tokenów": "",
        "Ton serdeczny, okazujący troskę lub wsparcie": "",
        "Ty:": "",
        "Ustawienia": "",
        "Ustawienia modeli": "",
        "Ustawienia modeli AI": "",
        "Usunięto ${removedCount} fragmentów dokumentu": "",
        "Usuń": "",
        "Usuń konwersację": "",
        "Usuń obraz": "",
        "Usuń plik": "",
        "Usuń załączony plik": "",
        "Użytkownik": "",
        "wczoraj": "",
        "Wewnętrzny błąd serwera": "",
        "Wpisz wiadomość...": "",
        "Wprowadź treść wiadomości...": "",
        "Wybierz konwersację, aby rozpocząć": "",
        "Wybierz lub utwórz konwersację": "",
        "Wybierz model do czatu": "",
        "Wybierz model embedding": "",
        "Wybierz model OCR": "",
        "Wybierz model TTS": "",
        "Wybierz plik": "",
        "Wybróbuj możliwości chatu AI": "",
        "Wystąpił błąd podczas przesyłania pliku.": "",
        "Wystąpił błąd podczas usuwania dokumentu.": "",
        "Wystąpił błąd podczas usuwania obrazu.": "",
        "Wystąpił błąd podczas wyszukiwania w dokumentach. Spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas streamingu. Spróbuj ponownie później.": "",
        "Wystąpił nieoczekiwany błąd.": "",
        "Wystąpił problem z pobraniem wiadomości.": "",
        "Wyślij ponownie": "",
        "Wyślij wiadomość": "",
        "Zadaj pytanie": "",
        "Załączone dokumenty:": "",
        "Załączone obrazy:": "",
        "Załączone pliki": "",
        "Zamknij": "",
        "Zapisz": "",
        "Zapisz i wyślij ponownie": "",
        "Zatrzymaj": "",
        "Zmień nazwę": "",
        "Zmień nazwę konwersacji": "",
        "Zmień ton": "",
        "Zmień ton tekstu": ""
    }
};
